import React, { useState } from 'react';
import { useField } from 'formik';
import moment from 'moment';
import TimePickerLabel from './TimePickerLabel';

function TimePicker({ name }) {
  const [field, meta, helpers] = useField(name);
  const [error, setError] = useState(null)

  function onChange(e) {
    validate(e.target.value);
    helpers.setValue(e.target.value);
  }

  function validate(value) {
    const regex = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;

    if (regex.test(value) === false) {
      setError('Nevalidní formát')
      return false;
    } 
      setError(null)
      return true;
    
  }

  function handleIncrease() {
    if (validate(field.value)) {
      const time = moment(field.value, 'HH:mm')
        .add(1, 'hour')
        .format('HH:mm');
      helpers.setValue(time);
    }
  }

  function handleDecrease() {
    if (validate(field.value)) {
      const time = moment(field.value, 'HH:mm')
        .subtract(1, 'hour')
        .format('HH:mm');
      helpers.setValue(time);
    }
  }

  return (
    <span className={`timepicker${error ? ' timepicker-error' : ''}`}>
      <button
        className="timepicker__inc-btn"
        type="button"
        onClick={handleIncrease}
      >
        inc
      </button>
      <input
        id={name}
        className="timepicker__input"
        type="text"
        name={name}
        value={field.value}
        onChange={onChange}
        maxLength={5}
      />
      <button
        className="timepicker__dec-btn"
        type="button"
        onClick={handleDecrease}
      >
        dec
      </button>
    </span>
  );
}

export default TimePicker;
